<div class="workspace no-back-btn">
  <div class="row" id="discover-influencers-management">
    <div class="col-md-12 discover-influencers-breadcumb">
      <div class="d-flex flex-row">
        <div class="d-flex breadcumb-container">
          <div class="row flex-g1">
            <div class="col-md-12 col-sm-12 breadcumb-header">
              <div class="d-flex flex-row flex-wrap">
                <div class="d-flex flex-row align-items-center">
                  <a class="not-underline first-line text-semi-bold-font">{{'discover.breadcumb_root' | translate}}</a>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-sm-12 breadcumb-subheader">
              {{'discover.discover_description' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="d-flex flex-row flex-nowrap discover-search-wrapper">
        <div class="d-flex flex-row flex-auto">
          <div class="col-sm-12 col-md-12">
            <discover-search #DiscoverySearchBar [discoverFilterBar]="discoverFilterBar"
                             [filterSearch]="currentFilterSearch"
                             (searchEvent)="onChangeSearchCriteria($event)"
                             (invalidCriteriaEvent)="onInvalidSearchCriteria()">
            </discover-search>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 discover-dislay-list">
      <achoo-infinite-scroll [scrollDistance]="scrollDistance"
                            [infiniteScrollThrottle]="throttle"
                            (scrollDownEvent)="onScrollDown()">
        <div class="d-flex flex-row flex-nowrap">
          <div class="d-flex flex-row flex-auto align-items-center full-width">
            <div class="full-width">
              <achoo-tabs [(selectedTabKey)]="tabKey" (tabClicked)="replaceTabState($event)" #discoverTabs>
                <achoo-tab [tabKey]="'posts'">
                  <ng-template tabHeading>
                    <a *ngIf="totalDisplayPost > 0">
                      {{'discover.nav-tabs.posts' | translate:{totalPosts: totalDisplayPost | formatNumberToString} }}
                    </a>
                    <a *ngIf="!totalDisplayPost || totalDisplayPost === 0">
                      {{'discover.nav-tabs.post' | translate}}
                    </a>
                    <achoo-icon-tooltip tooltipMsg="{{'info_box.discover.num_of_post' | translate}}"></achoo-icon-tooltip>
                  </ng-template>
                  <div class="tab-content">
                    <div class="col-md-12 col-sm-12 tab-post">
                      <div class="col-md-12 col-sm-12" *ngIf="showWarningSearchMessage">
                        <span *ngIf="!searchRunning && !missingRequiredFilters && discoverPosts.length === 0">
                          {{'discover.search_bar.no_post_result' | translate}}
                        </span>
                      </div>
                      <app-post-list #DiscoverPostList *ngIf="discoverPosts"
                                    [postList]="discoverPosts"
                                    [previewMode]="true"
                                    [influencerGroupId]="influencerGroupId"
                                    [bottomBar]="bottomBar"
                                    [gutter]="0"
                                    [target]="target"
                                    (isLayoutCompleted)="afterRenderPostList()"
                                    (openIncompleteStory)="openIncompletedStoryWarning($event)"
                                    (selectToPreviewPost)="onSelectedPost($event)">
                      </app-post-list>
                      <achoo-placeholder [placeholderId]="'inDiscoverPostHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="false">
                      </achoo-placeholder>
                    </div>
                  </div>
                </achoo-tab>
                <achoo-tab [tabKey]="'influencers'">
                  <ng-template tabHeading>
                    <a *ngIf="totalDisplayInfluencer > 0">
                      {{'discover.nav-tabs.influencers' | translate:{totalInfluencers: totalDisplayInfluencer | formatNumberToString} }}
                    </a>
                    <a *ngIf="!totalDisplayInfluencer || totalDisplayInfluencer === 0">
                      {{'discover.nav-tabs.influencer' | translate}}
                    </a>
                    <achoo-icon-tooltip tooltipMsg="{{'info_box.discover.num_of_infl' | translate}}"></achoo-icon-tooltip>
                  </ng-template>
                  <div class="tab-content">
                    <div class="col-md-12 col-sm-12 tab-influencer">
                      <div class="col-md-12 col-sm-12" *ngIf="showWarningSearchMessage">
                        <span *ngIf="!searchRunning && !missingRequiredFilters && discoverInfluencers.length === 0">
                          {{'discover.search_bar.no_result' | translate}}
                        </span>
                      </div>

                        <div *ngFor="let discoverInfluencer of discoverInfluencers; trackBy: trackByFn" >
                          <preview-influencer-item
                            [influencer]="discoverInfluencer"
                            [discoverFilter]="currentFilterSearch"
                            (laidOutCompleted)="afterLaidOutInfluencerPreviewItem($event)"
                            (selectedInfluencer)="onSelectedInfluencer($event)">
                          </preview-influencer-item>
                        </div>

                      <achoo-placeholder #discoverPlaceholder
                                         [placeholderId]="'inDiscoverInfluencerHolder'"
                                         [normalPlaceholder]="true"
                                         [isFullscreenLoader]="false"
                                         [showWarningMessage]="false">
                      </achoo-placeholder>
                    </div>
                  </div>
                </achoo-tab>
              </achoo-tabs>
            </div>
            <div class="order-bar-container">
              <order-bar [discoverFilter]="currentFilterSearch" (eventOrderDiscoverList)="orderDiscoverList($event)"></order-bar>
            </div>
          </div>
        </div>
      </achoo-infinite-scroll>
    </div>
    <div class="col-md-12">
      <div class="d-flex flex-auto justify-content-center">
        <span class="subscription-warning" *ngIf="shouldShowSubscriptionWarning" [innerHTML]="'discover.subscription_warning' | translate:{maxResultPerSearch: maxResultPerSearch, totalResult: totalDiscoveryResult | formatNumberToString}">
        </span>
      </div>
    </div>
    <div #bottomBar class="bottombar"
        [ngClass]="{'open': activeBottomBar === 'active', 'collapsed': activeBottomBar === 'inactive'}">
      <div class="row full-height">
        <div class="col-md-12 col-sm-12 d-flex">
          <bottombar-influencer-fragement class="d-flex flex-auto full-width"
                                          [influencerList]="selectedPreviewInfluencers"
                                          [influencerGroupId]="influencerGroupId"
                                          [influencerGroup]="influencerGroup"
                                          [discoverInfluencer]="true"
                                          [campaignList]="campaignList"
                                          [influencerGroupList]="influencerGroupList"
                                          [projectList]="discoverFilterBar.projects"
                                          [postList]="selectedPreviewPosts"
                                          [campaignListToPost]="campaignListToPost"
                                          (closeBottomBarCallback)="closeBottonBar($event)"
                                          (openBottomBarCallback)="beforeActiveBottomBar($event)"
                                          (clearSelectionCallback)="clearSelection($event)"
                                          (previewBottomBarOpen)="onPreviewBottomBarOpen($event)"
                                          (afterAddNewProject)="afterAddNewProjectFromBottombar($event)"
                                          (clearDiscoverResultAndFilter)="showClearFilterWarningPopup()">
          </bottombar-influencer-fragement>
        </div>
      </div>
    </div>
  </div>
</div>

<achoo-popup #InformationNoSearchFilterItemFound
              acceptBtnLabel="{{'common.btn.close' | translate}}"
              [isAlertPopup]="true"
              (acceptCallback)="hideAlertPopupMessage()"
              (cancelCallback)="hideAlertPopupMessage()">
  <span>{{'discover.information_no_search_filter' | translate}}</span>
</achoo-popup>
<achoo-popup #InformationInfluencerAreSearching
              acceptBtnLabel="{{'common.btn.close' | translate}}"
              [isAlertPopup]="true"
              (acceptCallback)="hideAlertPopupMessage()"
              (cancelCallback)="hideAlertPopupMessage()">
  <span>{{'discover.information_no_search_filter' | translate}}</span>
</achoo-popup>
<achoo-popup #ClearFilterWarningPopup
             acceptBtnLabel="{{'discover.clear_filter_accept_btn' | translate}}"
             cancelBtnLabel="{{'discover.clear_filter_cancel_btn' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="clearSearchResultAndFilter()"
             (cancelCallback)="hideAlertPopupMessage()">
  <span>{{'discover.clear_filter_warning_message' | translate}}</span>
</achoo-popup>
<achoo-popup #WarningOpenIncompletedStory
             [isAlertPopup]="true"
             modelTitle="{{'story.error.incompleted_title' | translate}}"
             [acceptBtnLabel]="'story.error.incompleted_btn' | translate"
             (acceptCallback)="hideAlertPopupMessage()"
             (closeCallback)="hideAlertPopupMessage()">
  <span>{{storyIncompleteMessage}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/discover/discover.component.html